import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    bankAccount: {
      serialize: 'records',
      deserialize: 'records'
    },
    merchantProfile: {
      embedded: 'always'
    }
  },
  primaryKey: 'token',
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if ('entity' in payload) {
      // eslint-disable-next-line no-param-reassign
      payload = payload.entity;
    }
    if ('entities' in payload) {
      // eslint-disable-next-line no-param-reassign
      payload = payload.entities;
    }
    return this._super(store, primaryModelClass, payload, id, requestType);
  },
  normalize(modelClass, hash) {
    if ('merchant_profile' in hash) {
      // eslint-disable-next-line no-param-reassign
      hash.merchant_profile.token = hash.token;
    }
    return this._super(modelClass, hash);
  },
  serialize(snapshot, options) {
    const ret = {};
    const json = this._super(snapshot, options);
    const removeTransferTag = snapshot.adapterOptions && snapshot.adapterOptions.removeTransferTag;
    if (json.deposit_tag === null || removeTransferTag) {
      delete json.deposit_tag;
    }
    if (json.business_type) {
      delete json.business_type;
    }
    ret.entity = json;
    return ret;
  }
});